import { string } from "superstruct";

export const RewardsQRCodeSchema = string();
